import React from "react"
import { Box, Typography } from "@mui/material"

export default function numSearchesColumn() {
    return {
        name: "num_searches", label: "Nº Searches",
        options: {
            setCellHeaderProps: () => ({ style: { whiteSpace: 'nowrap' } }),
            customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
                <Typography>{value}</Typography>
            </Box>
        }
    }
}